import { ActivatedRoute, ActivatedRouteSnapshot, Resolve } from '@angular/router';

import { Injectable } from '@angular/core';
import { map, EMPTY, Observable, tap, switchMap } from 'rxjs';
import { CaseInfoModel } from '../case-info-page-models';
import { CaseApiService } from '../../service/case-api.service';
import { PageTitleService } from '../../../../core/services/page-title.service';
import { IGetValueAsPromiseRequestPayload } from '../../../../shared/models/models';
import { GeneralApiService } from '../../../../shared/services/general-api.service';

@Injectable({ providedIn: 'root' })
export class CaseInfoResolver implements Resolve<CaseInfoModel | null> {
  
  constructor(
    private service: CaseApiService,
    private generalApiService: GeneralApiService    
    ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<CaseInfoModel | null> {
    const caseId = route.paramMap.get('caseId');
    if (!caseId) {
      return EMPTY;
    }

    const requestPayload: IGetValueAsPromiseRequestPayload = {
      columnName: 'DefendantNumber',
      tableName: 'tblCsCases',
      where: `FileNumber='${caseId}'`
    };
    return this.generalApiService.getValue(requestPayload).pipe(
      switchMap((defendantNumber: string) => {
    return this.service.getCaseInfo({ caseId }).pipe(
      map(
        data =>
          <CaseInfoModel>{
          caseId: caseId,
          defendantId : defendantNumber,
          caseDetails: { ...data?.meta },
          caseTopSectionData: {
            ...data,
            causeNumber: {
              show: data?.meta.causeNumber.show,
              data: data?.causeNumber ?? ''
            },
            caseWorker: {
              show: data?.meta.caseWorker.show,
              data: data?.caseWorker ?? '',
              label: data?.meta.caseWorker.label
            },
            report: {
              number: data?.report?.number ?? '',
              tooltip: data?.report?.title ?? ''
            },
            fingerprint: {
              show: data?.meta.ocn.show,
              label: data?.meta.ocn.label ?? '',
              tooltip: data?.fingerprint?.title,
              printNumber: data?.fingerprint?.number ?? ''
            },
            assigned: {
              name: data?.assigned?.name ?? '',
              emailData: {
                title: data?.assigned?.email,
                link: data?.assigned?.emailHref
              },
              phone: data?.assigned?.phone ?? '',
              address: data?.assigned?.address ?? ''
            },
            defenseAttorney: {
              name: data?.defenseAttorney?.name ?? '',
              emailData: {
                title: data?.defenseAttorney?.email,
                link: data?.defenseAttorney?.emailHref
              }
            }
          },
          isDefaultCriminal: data?.isDefaultCriminal
        }
      ),
    );
      })
    )
    
  }

}
